import CustomersPage from "./CustomersPage";

export default [
    {
        path: "/customers",
        name: "customers",
        component: CustomersPage
    }
]
